import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerBillingResellerListComponent } from './customer-billing-reseller-list/customer-billing-reseller-list.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { CustomerBillingResellerViewComponent } from './customer-billing-reseller-view/customer-billing-reseller-view.component';
import { CustomerBillingComponentsModule } from '../customer-billing-components/customer-billing-components.module';
import { CustomerBillingResellerEditComponent } from './customer-billing-reseller-edit/customer-billing-reseller-edit.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { BillingComponentsModule } from '@fi-app/billing/billing-components/billing-components.module';
import { CustomerBillingResellerListStateComponent } from './customer-billing-reseller-list/customer-billing-reseller-list-state.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { CustomerBillingResellerInfoComponent } from './customer-billing-reseller-edit/customer-billing-reseller-info/customer-billing-reseller-info.component';
import { CustomerBillingResellerPaymentInfoComponent } from './customer-billing-reseller-edit/customer-billing-reseller-payment-info/customer-billing-reseller-payment-info.component';
import { CustomerBillingResellerInvoiceInfoComponent } from './customer-billing-reseller-edit/customer-billing-reseller-invoice-info/customer-billing-reseller-invoice-info.component';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatButtonModule } from '@angular/material/button';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        BillingComponentsModule,
        CustomerBillingComponentsModule,
        MatRadioModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        SelectSearchModule,
        FiPageHeaderModule,
        MatButtonModule,
        FiErrorMessageModule,
    ],
    exports: [CustomerBillingResellerInfoComponent, CustomerBillingResellerInvoiceInfoComponent],
    declarations: [
        CustomerBillingResellerListComponent,
        CustomerBillingResellerViewComponent,
        CustomerBillingResellerEditComponent,
        CustomerBillingResellerListStateComponent,
        CustomerBillingResellerInfoComponent,
        CustomerBillingResellerPaymentInfoComponent,
        CustomerBillingResellerInvoiceInfoComponent,
    ],
})
export class CustomerBillingResellerModule {}
